"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.intToJapaneseWeekdayKanji = void 0;
const dateInt_1 = __importDefault(require("./dateInt"));
exports.intToJapaneseWeekdayKanji = Object.freeze({
    [dateInt_1.default.SUN]: "日",
    [dateInt_1.default.MON]: "月",
    [dateInt_1.default.TUE]: "火",
    [dateInt_1.default.WED]: "水",
    [dateInt_1.default.THUR]: "木",
    [dateInt_1.default.FRI]: "金",
    [dateInt_1.default.SAT]: "土",
});
